/** Published on <html> while the shell is mounted so portaled surfaces (toasts) can clear the sidebar. */
export const SIDEBAR_WIDTH_VAR = '--sp-sidebar-width';
/** The id the skip link targets; the content landmark. */
export const MAIN_CONTENT_ID = 'main-content';
//# sourceMappingURL=constants.js.map